import { gql } from "@apollo/client";

export const ServiceFragment = gql`
  fragment ServiceFragment on Service {
    _id
    label
    description
  }
`;

export const AdvantageFragment = gql`
  fragment AdvantageFragment on Advantage {
    _id
    isValidRequest
    remainQuantity
    program
    address {
      region
      address
      place_id
    }
    quantity
    maxAmount
    service {
      ...ServiceFragment
    }
  }
  ${ServiceFragment}
`;
